import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'chrono',
    standalone: true
})

/**
 * Transform timestamp to chrono hh:mm:ss
 */
export class ChronoPipe implements PipeTransform{
    
    transform(timestamp: number):string {
        if (timestamp === null || timestamp === undefined) {
            return '';
          }

          const hours = Math.floor(timestamp / 3600);
          const minutes = Math.floor((timestamp % 3600) / 60);
          const seconds = Math.floor(timestamp % 60); // Utilisez Math.floor() pour obtenir l'entier le plus proche
      
      
          const hoursStr = (hours < 10) ? `0${hours}` : `${hours}`;
          const minutesStr = (minutes < 10) ? `0${minutes}` : `${minutes}`;
          const secondsStr = (seconds < 10) ? `0${seconds}` : `${seconds}`;
      
          if (hours > 0) {
            return `${hoursStr}:${minutesStr}:${secondsStr}`;
          } else {
            return `${minutesStr}:${secondsStr}`;
          }
    }
}